<template>
  <el-menu class="el-menu-demo" mode="horizontal" background-color="#304156" text-color="#fff" active-text-color="#fff">
    <!--    <el-button class="buttonimg">-->
    <!--      <img class="showimg" :src="collapsed?imgsq:imgshow" @click="toggle(collapsed)">-->
    <!--    </el-button>-->
<!--    <div class="topSpan">腾亿新能源运营管理云平台</div>-->
    <div class="topSpan">{{platformTitle}}</div>
    <el-submenu index="2" class="submenu">
      <template slot="title">{{userNickName}}</template>
      <el-menu-item @click="toSetting()" index="2-1">设置</el-menu-item>
<!--      <el-menu-item @click="content()" index="2-2">个人中心</el-menu-item>-->
      <el-menu-item @click="exit()" index="2-3">退出</el-menu-item>
    </el-submenu>
  </el-menu>
</template>

<script>
  import {mapGetters} from 'vuex'

  export default {
    name: 'topheader',
    data() {
      return {
        collapsed: true,
        imgshow: require('../assets/img/show.png'),
        imgsq: require('../assets/img/sq.png')
      }
    },
    computed: {
      ...mapGetters([
        'nickname',
        'realName',
        'platformName'
      ]),
      userNickName: {
        get() {
          return this.realName || this.nickname
        }
      },
      platformTitle: {
        get() {
          return this.platformName ? this.platformName : '腾亿新能源运营管理云平台'
        }
      }
    },
    // 创建完毕状态(里面是操作)
    created() {
    },
    methods: {
      toSetting() {
        this.$router.push({name: 'personalSettings'})
      },
      // 退出登录
      exit() {
        this.$confirm('退出登录, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning',
          center: true
        }).then(async () => {
          try {
            await this.$store.dispatch('user/deleteUserInfo', this.nickname)
          } finally {
            await this.$store.dispatch('user/logout')
            location.reload()
          }
        }).catch(() => {
        })
      },
      // 切换显示
      toggle(showtype) {
        this.collapsed = !showtype
        this.$root.Bus.$emit('toggle', this.collapsed)
      }
    }
  }

</script>

<style scoped>
  .el-menu-vertical-demo:not(.el-menu--collapse) {
    border: none;
    height: 60px;
  }

  .el-menu-demo {
    height: 60px;
  }

  .submenu {
    float: right !important;
  }

  .buttonimg {
    height: 0px !important;
    background-color: transparent;
    border: none;
  }

  .showimg {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 10px;
    left: 15px;
  }

  .showimg:active {
    border: none;
  }

  .el-menu.el-menu--horizontal {
    border-bottom: 0px;
  }

  .topSpan {
    /*width: 20px;*/
    /*height: 20px;*/
    /*position: absolute;*/
    /*top: 10px;*/
    display: inline-block;
    float: left;
    text-align: left;
    padding-left: 15px;
    /*margin-left: 20px;*/
    color: white;
    font-size: 20px;
    height: 60px;
    /*width: 240px;*/
    line-height: 60px;
  }

  .topSpan:focus {
    outline: none;
  }
</style>
<style>
  .el-menu--horizontal > .el-submenu .el-submenu__title {
    height: 60px;
    line-height: 60px;
    border-bottom: 2px solid transparent;
    color: #fff;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/topheader.vue